/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_TitleInputs */

const en_editor_title = /** @type {(inputs: Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const de_editor_title = /** @type {(inputs: Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Editor_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_title = /** @type {((inputs?: Editor_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_title(inputs)
	return en_editor_title(inputs)
});